<template>
  <el-dialog
    :visible.sync="show"
    width="80%"
    title="教练分享"
    :close-on-click-modal="false"
  >
    <div class="container">
      <el-form :inline="true">
        <el-form-item label="姓名">
          <el-input v-model="name"></el-input>
        </el-form-item>
        <el-form-item label="电话">
          <el-input v-model="phone"></el-input>
        </el-form-item>
        <el-form-item label="教学类目">
          <el-select
            v-model="teaching_categories"
            clearable
            name="categories_child"
            remote
            style="width: 150px"
          >
            <el-option
              v-for="item in listPageChild"
              :key="item.id"
              :label="item.name"
              :value="item.name"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="性别">
          <el-select
            clearable
            v-model="sex"
            placeholder="请选择"
            style="width: 150px"
          >
            <el-option label="男" :value="1"> </el-option>
            <el-option label="女" :value="2"> </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="城市">
          <el-cascader
            clearable
            v-model="cityList"
            :options="cityoptions"
            :props="cityProps"
            :placeholder="cityList[1]"
          ></el-cascader>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="getList(1)">搜索</el-button>
        </el-form-item>
      </el-form>
      <auto-table
        :DataList="DataList"
        :option="Option"
        :total="Total"
        @changePage="getList"
      >
        <template #avatar="{ row }">
          <div>
            <el-avatar
              shape="square"
              :size="100"
              fit="contain"
              :src="row.head_portrait"
            ></el-avatar>
          </div>
        </template>
        <template #sex="{ row }">
          <div v-if="row.sex === 1">男</div>
          <div v-if="row.sex === 2">女</div>
        </template>
        <template #handler="{ row }">
          <div>
            <el-button type="success" size="small" @click="send(row)"
              >发送</el-button
            >
          </div>
        </template>
      </auto-table>
    </div>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      DataList: [],
      Option: [
        { name: "名称", value: "name" },
        { name: "城市", value: "city" },
        { name: "头像", value: "avatar", type: "custom" },
        { name: "性别", value: "sex", type: "custom" },
        { name: "电话", value: "phone" },
        { name: "类目", value: "teaching_categories" },
        { name: "服务价格", value: "min_price" },
        { name: "操作", value: "handler", type: "custom" },
      ],
      Total: 0,
      status: "",
      listPageChild: [],
      name: "",
      phone: "",
      teaching_categories: "",
      sex: "",
      show: false,
      cityoptions: [],
      cityProps: {
        checkStrictly: true,
        value: "district",
        label: "district",
        children: "childrens",
      },
      cityList: [],
    };
  },

  mounted() {
    this.cityoptions = JSON.parse(localStorage.getItem("addrList"));
    this.GetListPageChild();
  },

  methods: {
    send(row) {
      this.$emit("send", row);
      this.show = false;
    },
    open() {
      this.show = true;
    },
    GetListPageChild() {
      let url = this.$axios({
        url: "/user/mechanismCategory/queryListPageChild",
        params: {
          type: 2,
          status: 2,
          source: "课程",
        },
      }).then((res) => {
        this.listPageChild = res.data.data;
      });
    },
    //获取列表
    getList(v) {
      let params = {
        currentPage: page,
        pageSize: 10,
        status: 2,
        hide: false,
        title: this.name,
        phone: this.phone,
        teaching_categories: this.teaching_categories,
        sex: this.sex,
        coach_types: "expert,consu",
      };

      if (this.cityList.length > 0) {
        let len = this.cityList.length;
        let list = ["province", "city", "district"];
        for (let i = 0; i < len; i++) {
          params[list[i]] = this.cityList[i];
        }
      }
      let page = v || 1;
      this.$axios({
        url: "/user/coach/querySimp",
        params,
      }).then((res) => {
        this.DataList = res.data.data;
      });
    },
  },
};
</script>

<style lang="less" scoped>
</style>